import useReCaptchaV3 from '~/client/components/Auth/Shared/utils/useReCaptchaV3';
import useCid from '~/client/hooks/cookies/marketing/useCid';
import useRefAff from '~/client/hooks/cookies/marketing/useRefAff';
import useRefCode from '~/client/hooks/cookies/marketing/useRefCode';
import useFriendRef from '~/client/hooks/cookies/useFriendRef';
import useSite from '~/client/hooks/useSite';
import { useRegisterFastSignupMutation } from './graphql/RegisterFastSignupMutation.generated';
import type { RegisterMutation } from '../../../FormRegister/useFormRegister/useHandleRegister/graphql/RegisterMutation.generated';
import useHandleRegisterResponse from '../../../FormRegister/useFormRegister/useHandleRegister/useHandleRegisterResponse';
import type FormValues from '../FormValuesForFastSignup';

const useHandleRegisterFastSignup = ({
  isCaptchaRequired,
}: {
  isCaptchaRequired: boolean;
}) => {
  const [registerFastSignup] = useRegisterFastSignupMutation();
  const { handleRegisterResponse } = useHandleRegisterResponse();
  const { site } = useSite();
  const { getV3Token, captchaVersion } = useReCaptchaV3({ isRegister: true });
  const [refAff] = useRefAff();
  const [friendRef] = useFriendRef();
  const [cid] = useCid();
  const refCode = useRefCode();

  const handleRegisterFastSignup = async (values: FormValues) => {
    const { email, password, captcha } = values;
    const isRecaptchaV3 = captchaVersion === 'v3' && !isCaptchaRequired;
    const version = isRecaptchaV3 ? 'v3' : 'v2';
    const captchaToken = isRecaptchaV3 ? await getV3Token() : captcha;

    const { data } = await registerFastSignup({
      variables: {
        input: {
          site,
          email,
          password,
          captcha: captchaToken,
          captchaVersion: version,
          cid,
          refAff,
          refCode,
          friendRef,
        },
      },
    });
    return handleRegisterResponse(
      data?.userManagementFastSignup as RegisterMutation['userManagementRegisterAsUser'],
    );
  };
  return { handleRegisterFastSignup };
};

export default useHandleRegisterFastSignup;
